import React, {useState, useEffect} from 'react'
import "@material-tailwind/react/tailwind.css";
import { Link } from 'react-router-dom'
import '../CSS/Nav.css'
import { useRef } from 'react';

const NavBar = () => {

    
    const [visibleMenu, setVisibleMenu] = useState(false);
    const [showCross, setShowCross] = useState(false);
    const [activeLink, setActiveLinks] = useState('');

    const handleMenuClick = () => {
        setVisibleMenu(true);
        setShowCross(true);
        
    }

    const handleActiveLink = () => {
        setActiveLinks('activeNav');
        setTimeout(setActiveLinks(''), 2000);
        
    }


    // const [show,handleShow] = useState(false);

    // useEffect( () => {
    //     window.addEventListener('scroll', () => {
    //         if(window.scrollY > 200){
    //             handleShow(true);
    //         }
    //         else handleShow(false);
    //     });
       
    // }, [])
    const handleCrossClick = () => {
        setVisibleMenu(false);
        setShowCross(false);
    }

    const node = useRef();
    useEffect(() => {
        
        
        document.addEventListener("mousedown", handleCrossClick());
        return () => {
            document.removeEventListener("mousedown", handleCrossClick());
        };
    }, []);

  

    return (
        <>
        <div className="newNavBar" ref={node}>
            <div className='newNavMenu'>
                { !showCross ? (
                    <i className="fas fa-bars" id='hideMenuIcon1080'  onClick={(e) => handleMenuClick() }></i>
                ) : (
                    <i className="fas fa-times-circle" id='hideMenuIcon1080' onClick={(e) => handleCrossClick()}></i>
                ) 
                }        
            </div>  
            <div className="newNavLogo">
                <h2>LivLife<i className="far fa-heart"></i></h2>
            </div>
            
            <div className="LoginLogoutBtn">
                
            </div>
           
        </div>
                    <div className={visibleMenu ? "showMenu" : "hiddenMenu"}>
                    <ul>
                            <li onClick={(e) => handleCrossClick()}>
                                <Link to='/'><i className="fas fa-home"></i>
                                <p className={activeLink} onClick={(e) => handleActiveLink()}>Home</p>
                                </Link>
                            </li>
                            <li onClick={(e) => handleCrossClick()}>
                                <Link to='/Counsellors_page'><i className="fas fa-user"></i>
                                <p className={activeLink} onClick={(e) => handleActiveLink()}>Counsellors</p>
                                </Link>
                            </li>
                            <li onClick={(e) => handleCrossClick()}>
                                <Link to='/typeofTest'><i className = "fas fa-stethoscope"></i>
                                <p className={activeLink} onClick={(e) => handleActiveLink()}>Self Test</p>
                                </Link>
                            </li>
                            <li onClick={(e) => handleCrossClick()}>
                                <Link to='/AppointmentPage'><i className="fas fa-clock"></i>
                                Appointment
                                </Link>
                            </li>
                            <li onClick={(e) => handleCrossClick()}>
                                <Link to='/Profile_Page'><i className="fas fa-address-card"></i>
                                Profile
                                </Link>
                            </li>
                            <li onClick={(e) => handleCrossClick()}>
                                <Link to='/Booking_Page'><i className="fas fa-calendar-alt"></i>
                                Booking
                                </Link>
                            </li>  
                    </ul>
                    </div>
        </>
    )
}

export default NavBar
